var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{staticStyle:{"width":"120px"},attrs:{"type":"primary","disabled":!_vm.isuse},on:{"click":_vm.getcode}},[_vm._v(_vm._s(_vm.msg))])}
var staticRenderFns = []

export { render, staticRenderFns }